<template>
  <div
    :id="
      $route.name == 'NewHome' ||
      $route.name == 'WenKu' ||
      $route.name == 'Result'
        ? 'newapp'
        : 'app'
    "
    :style="$route.name == 'View' ? { height: '100vh' } : ''"
  >
    <Header v-if="$route.name != 'NewHome'"></Header>

    <router-view></router-view>

    <Footer v-if="$route.name != 'NewHome' && $route.name != 'WenKu'"></Footer>
  </div>
</template>

<script>
import Header from './components/header.vue'
import Footer from './components/footer.vue'
import "animate.css"
import {
  getArticleList
} from './api/api'
export default {
  components: {
    Header,
    Footer
  },
  name: 'App',
  created: function () {
    // getArticleList().then(res => {
    //   console.log(res);
    // })
  }
}
</script>

<style lang="less">
body {
  margin: 0;
}
html {
  font-size: 37.5px;
}
* {
  scrollbar-width: thin;
  scrollbar-color: #eee #ccc;
}

// ::-webkit-scrollbar {
//   width: 8px;
//   // height: 8px;
//   background: #eee;
// }
/*定义滑块 样式*/
::-webkit-scrollbar-thumb {
  // height: 100px; /* 滚动条滑块长度 */
  background-color: #ccc;
}
*::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background: #eee;
}
/*定义滑块 样式*/
*::-webkit-scrollbar-thumb {
  height: 100px; /* 滚动条滑块长度 */
  background-color: #ccc;
}

#app {
  display: flex;
  flex-direction: column;
  // max-width: 1440px;
  // min-width: 1425px;
  margin: auto;
  width: 100%;
  overflow: hidden;
  font-size: 37.5px;
}

@media screen and (max-width: 768px) {
  #app {
    max-width: 100%;
    min-width: 100%;

    margin: auto;
  }
}
#newapp {
  width: 100%;
  height: 100%;
  font-size: 16px;
  min-width: 1602px;
  overflow: hidden;
  // min-height: 768px;
  // transition: all 4s;
}

// body {
//   margin: 0;
//   padding: 0;
// }

// .header {
//   height: 2rem;
//   padding-left: 3rem;
// }

// .menu {
//   width: 3.467rem;
//   height: 0.827rem;
//   background: url(../static/menu/menu_bg.png) 100% no-repeat;
//   background-size: 100% 100%;
// }

// .title {
//   font-size: 0.45rem;
// }
// <style src="./pages/common.css" />
// <style src="./pages/index.css" />
</style>







// WEBPACK FOOTER //
// src/App.vue